<template>
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-8 h-8">
        <path d="M3 9.5H6V15.5H3V9.5Z" fill="white" :fill-opacity="charge > 0 ? '' : '0.25'"/>
        <path d="M7 9.5H10V15.5H7V9.5Z" fill="white" :fill-opacity="charge > 25 ? '' : '0.25'"/>
        <path d="M11 9.5H14V15.5H11V9.5Z" fill="white" :fill-opacity="charge > 50 ? '' : '0.25'"/>
        <path d="M15 9.5H18V15.5H15V9.5Z" fill="white" :fill-opacity="charge > 75 ? '' : '0.25'"/>
        <path d="M3 6.5C2.20435 6.5 1.44129 6.81607 0.87868 7.37868C0.316071 7.94129 0 8.70435 0 9.5L0 15.5C0 16.2956 0.316071 17.0587 0.87868 17.6213C1.44129 18.1839 2.20435 18.5 3 18.5H18C18.7956 18.5 19.5587 18.1839 20.1213 17.6213C20.6839 17.0587 21 16.2956 21 15.5V9.5C21 8.70435 20.6839 7.94129 20.1213 7.37868C19.5587 6.81607 18.7956 6.5 18 6.5H3ZM18 8C18.3978 8 18.7794 8.15804 19.0607 8.43934C19.342 8.72064 19.5 9.10218 19.5 9.5V15.5C19.5 15.8978 19.342 16.2794 19.0607 16.5607C18.7794 16.842 18.3978 17 18 17H3C2.60218 17 2.22064 16.842 1.93934 16.5607C1.65804 16.2794 1.5 15.8978 1.5 15.5V9.5C1.5 9.10218 1.65804 8.72064 1.93934 8.43934C2.22064 8.15804 2.60218 8 3 8H18ZM24 12.5C24 13.0967 23.7629 13.669 23.341 14.091C22.919 14.5129 22.3467 14.75 21.75 14.75V10.25C22.3467 10.25 22.919 10.4871 23.341 10.909C23.7629 11.331 24 11.9033 24 12.5Z" fill="white"/>
    </svg>
</template>

<script>
export default {
  name: "BatteryStatus",
  props: [
    'charge'
  ]
};
</script>

<style>
</style>